import {Component, Inject, OnInit} from '@angular/core';
import {Partner} from '../../../shared/interface/partner';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ofwca} from '../../../shared/interface/ofwca';
import {SelfBillingForm} from "../../../shared/interface/SelfBillingForm";

export interface ContractAddDialogData {
  partner?: Partner;
  ofwca?: Ofwca;
  selfBillingFormObject?: SelfBillingForm;
}

@Component({
  selector: 'app-contract-add-dialog',
  templateUrl: './contract-add-dialog.component.html',
  styleUrls: ['./contract-add-dialog.component.scss']
})
export class ContractAddDialogComponent implements OnInit {
  partnerObject?: Partner = null;
  ofwcaObject?: Ofwca = null;
  selfBillingFormObject?: SelfBillingForm = null;

  constructor(
    public dialogRef: MatDialogRef<ContractAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContractAddDialogData,
  ) {
    this.partnerObject = data.partner;
    this.ofwcaObject = data.ofwca;
    this.selfBillingFormObject = data.selfBillingFormObject;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
